/**
*
* RedForm
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import fetchData from 'helpers/fetchData';
import cloneDeep from 'helpers/cloneDeep';
import setLanguageContent from 'helpers/setLanguageContent';
import isCheckbox from 'helpers/isCheckbox';
import getForm from 'components/Templates/general/getForm';
import handlePublicTemplateOpenUrl from 'components/Templates/general/handlePublicTemplateOpenUrl';

import Wrapper from 'components/Templates/dynamics/Wrapper';


import defaultTextValues from './defaultTextValues';




class RedForm extends React.Component {

  constructor(props) {
    super();

    this._isMounted = false;

    const {
      commonData,
      forms
    } = props;

    const {
      componentPayload
    } = commonData;

    const {
      formId
    } = componentPayload;


    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleSend = this.handleSend.bind(this);

    const thisGetForm = getForm(formId, forms);

    this.state = {
      formData: {},
      formDataPayload: [],
      formState: {},
      email: '',
      isSuccessfull: false,
      isSending: false,
      errorFields: {},
      ...thisGetForm
    };
  }


  async handleSend() {

    if (this.state.isSending) return;
    if (!this._isMounted) return;

    this.setState({
      isSending: true
    });

    const {
      commonData, 
      defaultValues,
      commonProps
    } = this.props;

    const {
      organizationId,
      templateId,
    } = commonData;

    const {
      formState,
      email,
      formData
    } = this.state;

    const sendForm = await fetchData({
      payload: {
        templateId: templateId,
        organizationId: organizationId,
        email: email,
        formId: formData.formId,
        content: formState,
        acaraPrivacy: true,
        urlSearchParams: window.urlSearchParams
      },
      url: 'ajaxHandleLake',
      upload: true
    });
    
    if (!this._isMounted) return;

    const { status, statusText, errorFields } = sendForm;

    if (status === 'success') {
  
      this.setState({
        isSending: false,
        isSuccessfull: true
      });


      if (formData && formData.openAfterUrl) {
        const isFullUrlHref = formData.openAfterUrl.includes('https://') ||  formData.openAfterUrl.includes('http://');
        if (isFullUrlHref) {
          let otherWindowUrl = window.open(formData.openAfterUrl, '_blank');
          otherWindowUrl.opener = null;
        }
      }

      const getEventTitle = window.eventData && eventData && eventData.template && eventData.template.templateSchema ? setLanguageContent(eventData.template.templateSchema, 'title', 'en') : 'purchase';

      if (window && window.formCustomOverride && !window.formCustomOverrideDisable) {
        return window.formCustomOverride(getEventTitle, formData, formState, email);
      }
      
      if ((typeof ga === 'function' || typeof google_tag_manager === 'object')) {
         dataLayer.push({
          'event': 'Acara - Events',
          'category': 'Acara - Events',
          'action': formData.customAnalyticsAction ? formData.customAnalyticsAction : 'acara.form.send',
          'pageTitle': document.title,
          'eventTitle': getEventTitle,
          'label': formData.customAnalyticsLabel ? formData.customAnalyticsLabel : formData.title,
        });
      }
    

      return;

    }

    this.setState({
      data: '',
      error: statusText,
      isSending: false,
      errorFields: errorFields ? errorFields : {}
    });

  }


  handleFormChange(payload, isCheckbox) {

    const {
      updateType,
      value,
      type
    } = payload;

    if (!this._isMounted) return;

    this.setState((state) => {

      const newForm = cloneDeep(state.formState);

      const newPayload = {
        formState: newForm
      };
 
      if (isCheckbox) newPayload.formState[updateType] = !newPayload.formState[updateType];
      if (type === 'email') newPayload.email = value;
      if (!isCheckbox)  newPayload.formState[updateType] = value;

      return newPayload;
    });
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentDidUpdate(prevProp) {

    const {
      commonData,
      forms
    } = this.props;


    const {
      componentPayload
    } = commonData;

    if (!componentPayload) return;


    const {
      formId
    } = componentPayload;


    if (prevProp.commonData.componentPayload.formId !== formId) {
      const getFormData = getForm(formId, forms);
      if (getFormData) this.setState(getFormData);
    }


  }



  componentWillUnmount() {
    this._isMounted = false;
  }



  render() {

    const {
      commonData,
      openEditor,
      commonProps,
    } = this.props;

    const {
      isEditor,
    } = commonProps;

    const {
      componentPayload
    } = commonData;

    const {
      formId
    } = componentPayload;



    const { customStyles } = commonData

    const { formDataPayload, formState, isSending, isSuccessfull, errorFields, error, formData } = this.state;

    const formsContent = formDataPayload && formDataPayload.length > 0 ? cloneDeep(formDataPayload).map((formContent) => {
        const checkbox = isCheckbox(formContent.type);

        let checkboxConent;
        if (checkbox) {
          if (formContent.isRequired && formContent.label && formContent.type !== 'privacy') formContent.label = formContent.label + ' *';
          const getInsideBrackets = formContent.label.match(/\[(.+?)\]/g);
          const insideValue = getInsideBrackets ? getInsideBrackets[0].replace('[', '').replace(']', '') : formContent.label;
          let removeSlashes = formContent.url ? formContent.url.replace(/^https\:\/\//, '').replace(/^http\:\/\//, '') : '';
          if (removeSlashes) {
            removeSlashes = new URL('https://'+removeSlashes);
            checkboxConent = () => { return {__html: formContent.label.replace(/\[(.+?)\]/g,`<a href="${removeSlashes}" onClick='${isEditor ? null : 'handlePublicTemplateOpenUrl(event)'}' rel="noopener"  target="_blank" style="color:${customStyles.linkColor}">${insideValue}</a>`)}; };
          } else {
            checkboxConent = () => { return {__html: formContent.label.replace(/\[(.+?)\]/g, insideValue)}; };
          }
        }


        const isPrivacy = formContent.type === 'privacy';

        if (isPrivacy) {
          return (
            <Wrapper
              {...commonProps}
              key={'RedForm-inputTile-'+formContent.inputId}
              
              typeOfStyle={'inputTileCheckbox'}
              editorData={
                {
                  editorType: 'inputTileCheckbox',
                  ...commonData
                }
              }
            >
              {checkboxConent ? <span dangerouslySetInnerHTML={checkboxConent()} /> : ''}
            </Wrapper>
          )
        }
        
        const hasErrorInput = errorFields[formContent && formContent && formContent.inputId && !errorFields[formContent.inputId] ? formContent.type : formContent && formContent.inputId ? formContent.inputId : ''];
        return (          
          <Wrapper
            {...commonProps}
            
            key={'RedForm-inputTile-'+formContent.inputId}
            typeOfStyle={checkbox ? 'inputTileCheckbox' : 'inputTile'}
            type={checkbox ? 'checkbox' : 'form'}
            checked={formState[formContent.inputId] ? true : false}
            formState={formState}
            formData={formContent}
            handleFormChange={this.handleFormChange}
            inputError={hasErrorInput}
            customStyleWrapper={
              hasErrorInput ? `
                color: rgba(255,98,86,1);
              ` : ''
            }
            editorData={
              {
                editorType: checkbox ? 'inputTileCheckbox' : 'inputTile',
                ...commonData
              }
            }
          >
            {checkboxConent ? <span dangerouslySetInnerHTML={checkboxConent()} /> : ''}
          </Wrapper>          
        );
      }) : '';

    if (formsContent && !formData.disableAcaraToc) formsContent.push((
      <Wrapper
        {...commonProps}
        typeOfStyle={'inputTileCheckbox'}
        key={'RedForm-inputTileCheckbox-Acara'}
        editorData={
          {
            editorType: 'inputTileCheckbox',
            ...commonData
          }
        }
      >
        By submitting I agree to Acara <a href="https://www.iubenda.com/privacy-policy/28920643" rel="noopener" target="_blank" style={{color:`${customStyles.linkColor}`, padding: '0 0.35rem'}}>privacy policy</a> & <a href="https://www.iubenda.com/terms-and-conditions/28920643" rel="noopener" target="_blank" style={{color:`${customStyles.linkColor}`, padding: '0 0.35rem'}}>terms of service</a>. *
      </Wrapper>
    ));
      

      
    const hasTextError = error && Object.keys(errorFields).length === 0;

    return (
      <Wrapper
        {...commonProps}
        key={`Wrapper-${commonData.sectionId}-${isSuccessfull}`}
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'columnsWrapper'}
            editorData={
                {
                  editorType: 'columnsWrapper',
                  ...commonData
                }
              }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'columnDescription'}
              editorData={
                  {
                    editorType: 'columnDescription',
                    ...commonData
                  }
                }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'title'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'title',
                    ...commonData
                  }
                }
              />
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'description'}
                type={'text'}
                editorData={
                    {
                      editorType: 'description',
                      ...commonData
                    }
                  }
              />
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'containerImage'}
                editorData={
                    {
                      editorType: 'containerImage',
                      ...commonData
                    }
                  }
              />

            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'columnForm'}
              editorData={
                  {
                    editorType: 'columnForm',
                    ...commonData
                  }
                }
            >

              {isSuccessfull ? (
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'thankYou'}
                  type={'text'}
                  defaultValues={defaultTextValues}
                  editorData={
                    {
                      editorType: 'thankYou',
                      ...commonData
                    }
                  }
                />
              ) : (
                <>
                  {formsContent ? formsContent : isEditor ? (
                    <div>
                      Nothing to display here... Select form from section editor
                    </div>
                  ) : ''}
                  {
                    hasTextError ? (
                      <Wrapper
                        {...commonProps}
                        
                        typeOfStyle={'errorWrapper'}
                        defaultValues={defaultTextValues}
                        editorData={
                          {
                            editorType: 'errorWrapper',
                            ...commonData
                          }
                        }
                      >
                        {error}
                      </Wrapper>
                    ) :''
                  }
                  {formDataPayload && formDataPayload.length > 0 ? (
                    <Wrapper
                      {...commonProps}
                      
                      typeOfStyle={'sendButton'}
                      type={'button'}
                      as={'button'}
                      handleClick={this.handleSend}
                      editorData={
                        {
                          editorType: 'sendButton',
                          ...commonData
                        }
                      }
                    >
                      {isSending ? 'Sending...' : formData && formData.buttonText ? formData.buttonText : 'Send'}
                    </Wrapper>
                  ) : ''}
                </>
              )}

            </Wrapper>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    );
  }
}

RedForm.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  forms: PropTypes.array,
};

export default RedForm;
